import {
  CONFIRM_BOOKING,
  CONFIRM_BOOKING_SUCCESS,
  CONFIRM_BOOKING_FAILED,
  CLEAR_BOOKING
} from "../store/types";
import store from '../store/store';
import { getSupabase } from '../config/configureSupabase';

export const clearBooking = () => (dispatch) => {
  dispatch({
    type: CLEAR_BOOKING,
    payload: null,
  });
};

export const addBooking = (bookingData) => async (dispatch) => {
  dispatch({
    type: CONFIRM_BOOKING,
    payload: bookingData,
  });

  const supabase = getSupabase();
  const userInfo = store.getState().auth?.profile;

  if (supabase) {
    try {
      const refCode = 'R-' + Math.floor(100000 + Math.random() * 900000);
      const newRoute = {
        reference_code: refCode,
        tenant_id: userInfo?.tenant_id || bookingData.tenant_id,
        status: 'PENDING',
        origin: typeof bookingData.pickup === 'object' ? bookingData.pickup : { add: bookingData.pickup },
        destination: typeof bookingData.drop === 'object' ? bookingData.drop : { add: bookingData.drop },
        total_distance_km: bookingData.estimateDistance || 0,
        total_duration_min: bookingData.estimateTime ? Math.round(bookingData.estimateTime / 60) : 0,
        notes: bookingData.notes || '',
        created_at: new Date().toISOString()
      };

      const { data, error } = await supabase.from('routes').insert([newRoute]).select().single();

      if (!error && data) {
        dispatch({
          type: CONFIRM_BOOKING_SUCCESS,
          payload: {
            booking_id: data.id,
            mainData: {
              ...data,
              booking_id: data.id
            }
          }
        });
        return;
      }
    } catch (err) {
      dispatch({
        type: CONFIRM_BOOKING_FAILED,
        payload: err.message,
      });
      return;
    }
  }

  dispatch({
    type: CONFIRM_BOOKING_FAILED,
    payload: "Erro ao salvar rota",
  });
};
